import api from "./api";

export async function addKb(documentId: string, itemId: string) {
  const addKbResponse = await api.post(
    `/documents/${documentId}/default_knowledge_base_items/${itemId}`,
  );
  return addKbResponse.data;
}
